import { Box } from '@hivewatch/dark'

export const NotificationIcon = ({
  color,
  size,
}: {
  /** Accent colour token for the badge (severity). */
  color: string
  size: string
}) => {
  return (
    <Box
      alignItems='center'
      bg={color}
      borderRadius='4px'
      h={size}
      justifyContent='center'
      mt='3px'
      position='absolute'
      w={size}
      zIndex='2'
    />
  )
}
